
import { getBankInfoListAll } from '@/api/bankInfo';
import { parseConcatNumber, parseRegisterNo } from '@/utils/filters';
import { ElForm } from 'element-ui/types/form';
import { Component, Vue } from 'vue-property-decorator';
import {
  checkUserId,
  joinBusinessUser,
  checkRegisterNo,
} from '@/api/client/user';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { getEncData } from '@/api/client/nice';
import { getIndustryListAll } from '@/api/industry';
import { getOptionItemList } from '@/api/optionItem';
import { IndustryItem } from './industryitem';

@Component({
  name: 'LoginPage',
  components: {
    VueDaumPostcode,
  },
})

export default class extends Vue {
  mounted() {
    this.getIndustryList();
    this.getBankList();
    this.getGreetingList();
    this.getEncData();
  }

  private industryList = [];

  private bankList = [];

  private greetingList = [];

  private encData: any = '';

  private commonApiUrl = process.env.VUE_APP_BASE_API;

  private apiUrl = process.env.VUE_APP_CLIENT_API;

  private loading = false;

  private form: any = {
    userId: '',
    userPassword: '',
    passwordCheck: '',
    actualName: '',
    concatNumber: '',
    business: {
      companyName: '',
      bossName: '',
      companyAddress: '',
      companyAddressDetail: '',
      registerNo: '',
      registerFileUid: '',
      email: '',
      bankCode: '',
      accountNo: '',
      accountFileUid: '',
      accountHolder: '',
      profileFileUid: '',
      greeting: '',
      managerName: '',
      managerTel: '',
      businessType: '',
      businessCategory: '',
      popbillId: '',
      taxType: 0,
    },
    privacy1: '',
    privacy2: '',
    privacy3: '',
    businessIndustryIdx: null,
  }

  private findAddressVisible = false;

  private fileSizeLimit = 10;

  private validateUserId = (rule:any, value:any, callback:any) => {
    if (value === '') {
      callback(new Error('아이디를 입력하세요.'));
    } else {
      const regUserId = /^[a-z0-9_-]{3,19}$/g;
      if (!regUserId.test(value)) {
        callback(new Error('영문, 숫자, 특수문자(-, _)로 4~20자로 입력하세요.'));
      } else {
        checkUserId(value).then((res) => {
          if (res.data) callback(new Error('이미 사용 중인 아이디입니다.'));
          else callback();
        });
      }
    }
  };

  private validatePasswordCheck = (rule:any, value:any, callback:any) => {
    if (value !== (this.$refs.form as any).model.userPassword) {
      callback(new Error('비밀번호가 일치하지 않습니다.'));
    } else {
      callback();
    }
  };

  private validateConcatNumber = (rule:any, value:any, callback:any) => {
    const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
    const regPhone2 = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/;
    if (!regPhone.test(value) && !regPhone2.test(value)) {
      callback(new Error('연락처 형식에 맞지 않습니다.'));
    } else {
      callback();
    }
  };

  /* eslint-disable */
  private validateRegisterNo = (rule:any, value:any, callback:any) => {
    const regRegisterNo = /^([0-9]{3})-?([0-9]{2})-?([0-9]{5})$/;
    if (!regRegisterNo.test(value)) {
      callback(new Error('사업자번호 형식에 맞지 않습니다.'));
    } else {
      checkRegisterNo({ registerNo: value }).then((res) => {
        if (!res.data.resultCode) callback(new Error(res.data.resultMessage));
        callback();
      }).catch(() => {
        return callback(new Error('사업자번호 검증 요청에 실패했습니다.'));
      });
    }
  };
  /* eslint-enable */

  private rules = {
    userId: [
      { required: true, message: '아이디를 입력해주세요.', trigger: ['change', 'blur'] },
      { validator: this.validateUserId, trigger: 'blur' },
    ],
    userPassword: [
      { required: true, message: '패스워드를 입력하세요.', trigger: ['change', 'blur'] },
      {
        min: 8,
        max: 20,
        message: '패스워드는 최소 8자, 최대 20자입니다.',
        trigger: ['change', 'blur'],
      },
    ],
    passwordCheck: [
      { required: true, message: '패스워드를 확인해주세요.', trigger: ['change', 'blur'] },
      { validator: this.validatePasswordCheck, trigger: ['change', 'blur'] },
    ],
    actualName: [
      { required: true, message: '성명을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    concatNumber: [
      { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
      { validator: this.validateConcatNumber, trigger: ['change', 'blur'] },
    ],
    business: {
      companyName: [
        { required: true, message: '회사명을 입력하세요.', trigger: ['change', 'blur'] },
      ],
      bossName: [
        { required: true, message: '대표자명을 입력하세요.', trigger: ['change', 'blur'] },
      ],
      companyAddress: [
        { required: true, message: '업체주소를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      registerNo: [
        { required: true, message: '사업자번호를 입력하세요.', trigger: ['change', 'blur'] },
        { validator: this.validateRegisterNo, trigger: 'blur' },
      ],
      registerFileUid: [
        { required: true, message: '사업자등록증을 업로드하세요.', trigger: ['change', 'blur'] },
      ],
      email: [
        { required: true, message: '이메일을 입력하세요.', trigger: ['change', 'blur'] },
        { type: 'email', message: '이메일형식으로 입력하세요.', trigger: ['change', 'blur'] },
      ],
      bankCode: [
        { required: true, message: '정산은행을 선택하세요.', trigger: ['change', 'blur'] },
      ],
      accountNo: [
        { required: true, message: '계좌번호를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      accountHolder: [
        { required: true, message: '예금주를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      accountFileUid: [
        { required: true, message: '통장사본을 업로드하세요.', trigger: ['change', 'blur'] },
      ],
      profileFileUid: [
        { required: true, message: '프로필 사진을 업로드하세요.', trigger: ['change', 'blur'] },
      ],
      greeting: [
        { required: true, message: '인사말을 선택하세요.', trigger: ['change', 'blur'] },
      ],
      managerName: [
        { required: true, message: '정산 담당자 성명을 입력하세요.', trigger: ['change', 'blur'] },
      ],
      managerTel: [
        { required: true, message: '정산 담당자 연락처를 입력하세요.', trigger: ['change', 'blur'] },
        { validator: this.validateConcatNumber, trigger: ['change', 'blur'] },
      ],
      businessType: [
        { required: true, message: '업태를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      businessCategory: [
        { required: true, message: '종목을 입력하세요.', trigger: ['change', 'blur'] },
      ],
    },
    businessIndustryIdx: [
      { required: true, message: '업종을 선택하세요.', trigger: ['change', 'blur'] },
    ],
    privacy1: [
      { required: true, message: '아래 내용에 동의함 체크해주세요.', trigger: ['change', 'blur'] },
    ],
    privacy2: [
      { required: true, message: '개인정보처리방침에 체크해주세요.', trigger: ['change', 'blur'] },
    ],
    privacy3: [
      { required: true, message: '가맹수칙에 체크해주세요.', trigger: ['change', 'blur'] },
    ],
  }

  private getIndustryList() {
    getIndustryListAll().then((res) => {
      this.industryList = res.data;
      this.industryList = this.industryList.filter((item: any) => item.name !== '일반상품');
    });
  }

  private getBankList() {
    getBankInfoListAll().then((res) => {
      this.bankList = res.data;
    });
  }

  private getEncData() {
    getEncData().then((res) => {
      this.encData = res.data;
    });
  }

  private filterConcatNumber() {
    this.form.concatNumber = parseConcatNumber(this.form.concatNumber);
  }

  private handleInputMangerTel() {
    this.form.business.managerTel = parseConcatNumber(this.form.business.managerTel);
  }

  private filterRegisterNo() {
    this.form.business.registerNo = parseRegisterNo(this.form.business.registerNo);
  }

  private handleJoin() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$confirm('가입 신청을 하시겠습니까? (※계산서 유형을 신중히 선택해주세요)', '확인', {
          confirmButtonText: '예',
          cancelButtonText: '아니오',
          type: 'warning',
        }).then(() => {
          this.loading = true;
          joinBusinessUser(this.form).then(() => {
            this.$message.success('회원가입이 완료되었습니다. 승인 후 로그인 가능합니다.');
            this.$router.push({ name: 'Login' });
            this.loading = false;
          }).catch(() => {
            this.$message.error('회원가입 요청에 실패했습니다.');
            this.loading = false;
          });
        }).catch(() => {
          // 취소
        });
      }
    });
  }

  private handleFindAddress() {
    this.findAddressVisible = !this.findAddressVisible;
  }

  private handleCompleteFindAddress(data: any) {
    this.handleFindAddress();
    this.form.business.companyAddress = data.roadAddress;
    this.form.business.companyAddressDetail = '';
  }

  private handleUploadSuccess(res: any, type: string) {
    if (type === 'registerFile') this.form.business.registerFileUid = res.uid;
    if (type === 'profile') this.form.business.profileFileUid = res.uid;
    if (type === 'accountFile') this.form.business.accountFileUid = res.uid;
  }

  /* eslint-disable */
  private handleBeforeUpload(file: File, type: string) {
    const isLimit = file.size / 1024 / 1024 < this.fileSizeLimit;
    const isImage = file.type.startsWith('image');
    const isPdf = file.name.endsWith('pdf');
    if (!isLimit) {
      this.$message.warning(`파일 용량은 ${this.fileSizeLimit}MB 를 초과 할 수 없습니다.`);
      return false;
    }
    if (type === 'profile') {
      if (!isImage) {
        this.$message.warning('이미지 파일만 업로드 가능합니다.');
        return false;
      }
    } else {
      if (!isPdf && !isImage) {
        this.$message.warning('PDF 파일 혹은 이미지 파일만 업로드 가능합니다.');
        return false;
      }
    }
    return true;
  }
  /* eslint-enable */

  private handleRemoveFile(type: string) {
    if (type === 'registerFile') this.form.business.registerFileUid = null;
    if (type === 'profile') this.form.business.profileFileUid = null;
    if (type === 'accountFile') this.form.business.accountFileUid = null;
  }

  private handleNicePopup() {
    const nicePopup = window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
    (this.$refs.niceForm as HTMLFormElement).action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
    (this.$refs.niceForm as HTMLFormElement).target = 'popupChk';
    (this.$refs.niceForm as HTMLFormElement).submit();
    const loop = setInterval(() => {
      if (nicePopup && nicePopup.closed) {
        clearInterval(loop);
        if ((document.getElementById('actualName') as any).value && (document.getElementById('concatNumber') as any).value) {
          this.form.actualName = (document.getElementById('actualName') as any).value;
          this.form.concatNumber = (document.getElementById('concatNumber') as any).value;
        }
      }
    }, 400);
  }

  private getGreetingList() {
    getOptionItemList('GREETING').then((res) => {
      this.greetingList = res.data;
    });
  }

  private removeSpaceFormData() {
    this.form.userId = this.form.userId.replace(/(\s*)/g, '');
    this.form.userPassword = this.form.userPassword.replace(/(\s*)/g, '');
    this.form.passwordCheck = this.form.passwordCheck.replace(/(\s*)/g, '');
  }
}
